import React, { Component } from 'react'
import TitleBar from '../components/TitleBar'
import UserPanel from '../login/UserPanel'
import UserList from '../login/UserList'
import UserSelector from '../login/UserSelector'
import { connect } from 'react-redux';
import { getUsers, updateSelectorList } from '../actions/loginActions'
import { getSystemUser, getTranslation } from '../actions/dataActions'
import { setCulture } from '../actions/layoutActions'
import cookie from 'react-cookie'
import * as general from '../constants/General'
import { hashHistory } from 'react-router'
import * as resource from '../constants/Resources'
import PropTypes from 'prop-types'

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.handleUserListItem = this.handleUserListItem.bind(this);
    this.setSelectedUser = this.setSelectedUser.bind(this);
    this.initScreen = this.initScreen.bind(this);
    this.users = [];
    this.state = {
      selectorList: [],
      lastuser: cookie.load(general.COOKIE_POS_LASTUSERID, { path: '/' }),
      userPanelVisibility: '',
      userListVisibility: ''
    }
  }
  
  componentDidMount() {
    if (this.props.loggedin !== undefined
    && this.props.loggedin.id > 0) {
      hashHistory.push('/overview');
    }
    this.initScreen(this.state.lastuser);
  }

  setSelectedUser(userid) {
    const selectorCopy = [];
    this.state.selectorList.map(selector => {
      if (selector.SystemUserId === userid) {
        selectorCopy.push(Object.assign({}, selector, {
          Selected: true
        }))
        return '';
      }
      selectorCopy.push(Object.assign({}, selector, {
        Selected: false
      }))
      return '';
    });

    this.setState({ selectorList: selectorCopy });
  }

  handleTouchTap(props) {
    this.setSelectedUser(props.SystemUserId);
  }

  handleUserListItem(props) {
    const systemUser = this.props.getSystemUser(props.SystemUserId);
    if (systemUser !== null) {
      this.props.setCulture(systemUser.Culture);
    }

    this.initScreen(props.SystemUserId);
    this.setState({ lastuser: props.SystemUserId });
  }

  initScreen(userId) {
    this.users = this.props.users;
    const lastuser = userId;

    this.users = [];
    let bottom = 0;

    if (lastuser > 0) {
      const systemUser = this.props.getSystemUser(parseInt(lastuser, 10));
      if (systemUser !== null) {
        this.users.push(systemUser);
        this.props.setCulture(systemUser.Culture);
      }
    } else if (this.props.users.length === 1) {
      this.users.push(this.props.users[0]);
      this.props.setCulture(this.props.users[0].Culture);
    }

    const lastuserset = (lastuser > 0) || (this.props.users.length === 1);
    const tempSelectorList = [];
    if (this.props.users.length > 1) {
      tempSelectorList.push({
        SystemUserId: 0,
        UserName: this.props.getTranslation(resource.OTHER_USER),
        Selected: !lastuserset,
        Bottom: bottom,
        Labels: []
      });
      bottom += 1;
    }

    this.users.map(user => {
      const userCopy = user;
      userCopy.Selected = lastuserset;
      tempSelectorList.push({
        SystemUserId: userCopy.SystemUserId,
        UserName: userCopy.UserName,
        Selected: lastuserset,
        Bottom: bottom,
        Labels: userCopy.Labels
      });
      bottom += 1;
      return '';
    })
    this.setState({ selectorList: tempSelectorList });
  }

  render() {
    let userPanelVisibility = '';
    let userListVisibility = '';
    let selectorListVisibility = '';
    if (this.props.splashModal.show) {
      selectorListVisibility = 'none';
      userListVisibility = 'none';
    }
    this.state.selectorList.map(selector => {
      if (selector.SystemUserId === 0 && (selector.Selected || this.props.splashModal.show)) {
        userPanelVisibility = 'none';
      }
      if (selector.SystemUserId > 0 && (selector.Selected || this.props.splashModal.show)) {
        userListVisibility = 'none'
      }

      return '';
    })
    return (
        <div className="loginwrapper">
            <TitleBar />
            <div className="overview">
               <UserList
                 visibility={userListVisibility}
                 onClick={this.handleUserListItem}
               />
            <div className="content">
              <div className="userwrapper">
                {
                this.users.map(user =>
                  <UserPanel
                    key={user.SystemUserId}
                    userid={user.SystemUserId}
                    username={user.UserName}
                    userLabels={user.Labels}
                    visibility={userPanelVisibility}
                    culture={user.Culture}
                  />
                )}
                </div>
            </div>
            </div>
            <div className="userselectorwrapper" style={{ display: selectorListVisibility }}>
           {
            this.state.selectorList.map(user => {
              return <UserSelector
              key={user.SystemUserId}
              SystemUserId={user.SystemUserId}
              UserName={user.UserName}
              Selected={user.Selected}
              onClick={this.handleTouchTap}
              Bottom={user.Bottom}
            />;
            }
            
            )
           }
            </div>
        </div>
    )
  }
}

LoginPage.propTypes = {
  users: PropTypes.array,
  getUsers: PropTypes.func.isRequired,
  setCulture: PropTypes.func.isRequired,
  loggedin: PropTypes.object,
  posList: PropTypes.array.isRequired,
  splashModal: PropTypes.object
}

function mapStateToProps(state) {
  return {
    users: state.loginState.users,
    loggedin: state.loginState.loggedin,
    posList: state.generalState.posList,
    splashModal: state.generalState.modal.splashModal
  }
}

export default connect(mapStateToProps, { getUsers, updateSelectorList, setCulture, getSystemUser, getTranslation })(LoginPage)



// WEBPACK FOOTER //
// src/pages/LoginPage.jsx